/**
 * Activity Mapper
 * Maps between JobActivityDto and component-level JobActivity types
 */

import type { JobActivityDto } from '../types/activity';
import type { JobActivity, ActivityType } from '@/types/job-activity';

/**
 * Map JobActivityDto to JobActivity for component consumption
 * Extracts metadata fields into component-friendly properties
 */
export function mapActivityDtoToJobActivity(dto: JobActivityDto): JobActivity {
  const metadata = dto.metadata || {};

  return {
    id: dto.id,
    jobId: dto.jobId,
    userId: dto.userId,
    userName: (metadata.userName as string) || 'Unknown User',
    activityType: dto.activityType as ActivityType,
    fieldName: metadata.fieldName as string | undefined,
    oldValue: metadata.oldValue as string | undefined,
    newValue: metadata.newValue as string | undefined,
    comment: metadata.comment as string | undefined,
    timestamp: dto.timestamp,
  };
}

/**
 * Map array of DTOs to JobActivities
 */
export function mapActivityDtosToJobActivities(dtos: JobActivityDto[]): JobActivity[] {
  return dtos.map(mapActivityDtoToJobActivity);
}
